/**
 * QrScanner
 * @module QrScanner
 */
import { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

interface Props {
	onScanSuccess: (decodeText: string) => void;
	onScanError?: (errorMessage: string) => void;
	facingMode?: 'environment' | 'user';
}

const QrScanner: React.FC<Props> = ({
	onScanSuccess,
	onScanError,
	facingMode = 'user',
}) => {
	const scannerRef = useRef<Html5Qrcode | null>(null);
	const qrCodeRegion = 'qr-code-region';

	const start = async () => {
		if (scannerRef.current) return;

		const html5QrCode = new Html5Qrcode(qrCodeRegion);

		scannerRef.current = html5QrCode;

		try {
			await html5QrCode.start(
				{ facingMode },
				{
					fps: 10,
					qrbox: (w: number, h: number) => {
						const minEdge = Math.min(w, h);

						const size = minEdge - 40; // 20px margin on each side

						return {
							width: size,
							height: size,
						};
					},
				},
				(decodedText: string) => {
					onScanSuccess(decodedText);
				},
				(errorMessage: string) => {
					// if (errorMessage.indexOf('NotFoundException') === -1) {
					// 	alert(errorMessage);
					// 	if (onScanError) onScanError(errorMessage);
					// }
				}
			);
		} catch (err) {
			//if (onScanError) onScanError(err);
		}
	};
	const stop = async () => {
		if (scannerRef.current) {
			await scannerRef.current.stop();
			await scannerRef.current.clear();
			scannerRef.current = null;
		}
	};

	useEffect(() => {
		start();
		return () => {
			stop();
		};
	}, []);

	return <div id="qr-code-region" />;
};

export default QrScanner;
